/** @jsxImportSource @emotion/react */
import { Flex, Link, LoadingIcon, Stack, Text } from "basis";
import { AccountLinkCard } from "components/AccountLink/AccountLinkCard";
import { SvgInline } from "components/SvgInline/SvgInline";
import { useAccounts } from "library/accounts";
import { useProducts } from "library/hooks/useProducts";
import { isNonEmptyArray } from "../../library/utils";
import { AccountList } from "./AccountList";
import { getProductCodes } from "./getProductCodes";

export const AccountsDashboardContent = () => {
  const accountsInfo = useAccounts();
  const productsInfo = useProducts();

  const personalLoans = accountsInfo.data?.personal_loans ?? [];
  const creditCards = accountsInfo.data?.credit_cards ?? [];
  const productList = [...personalLoans, ...creditCards];
  const productCodes = getProductCodes(productList, productsInfo);

  if (accountsInfo.isLoading) {
    return (
      <Flex height="200" placeItems="center">
        <LoadingIcon size="medium" />
      </Flex>
    );
  }

  if (accountsInfo.isError) {
    return (
      <Stack gap="8">
        <SvgInline name="error-dog" width="236" />
        <Text textStyle="heading5" textStyle-sm="heading4">
          We were unable to retrieve your accounts
        </Text>
        <Text>
          Please try again later or contact Latitude if the problem persists.
        </Text>
        <Link
          appearance="primary-button"
          width="216"
          href="/contact"
          newTab={false}
        >
          Contact Latitude
        </Link>
      </Stack>
    );
  }

  if (isNonEmptyArray(productCodes)) {
    return <AccountList productCodes={productCodes} />;
  }

  return (
    <div css={{ maxWidth: 360 }}>
      <AccountLinkCard
        header="You're ready to go!"
        body="You can now use the new Latitude Service Center to link to your existing Latitude products and manage them all in one place."
      />
    </div>
  );
};
